import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppLayout } from "./components/layout/AppLayout";
import { PageTransition } from "./components/PageTransition";
import { ContentLoader } from "./components/base/ContentLoader";
import { globalConfig } from "./content";

const HomeContent = React.lazy(() => import("./pages/HomePage"));
const QueEsperarPage = React.lazy(() => import("./pages/QueEsperarPage"));
const ExperienciasContent = React.lazy(() =>
  import("./pages/ExperienciasPage")
);
const UbicacionesPage = React.lazy(() => import("./pages/UbicacionesPage"));
const EventosPage = React.lazy(() => import("./pages/EventosPage"));
const PromocionesPage = React.lazy(() => import("./pages/PromocionesPage"));

const FarCryContent = React.lazy(() =>
  import("./pages/experiences/FarCryPage")
);
const SpaceMarineContent = React.lazy(() =>
  import("./pages/experiences/SpaceMarinePage")
);
const EngineeriumContent = React.lazy(() =>
  import("./pages/experiences/EngineeriumPage")
);
const ThreatLethalContent = React.lazy(() =>
  import("./pages/experiences/ThreatLethalPage")
);

const ExperienceDynamic = React.lazy(() =>
  import("./pages/experiences/ExperiencePage")
);

import { DeviceProvider } from "./context/DeviceContext.jsx";
import CookiesBanner from "./components/ui/CookiesBanner";

function App() {
  return (
    <DeviceProvider>
      <Router>
        <AppLayout pageConfig={globalConfig}>
          <PageTransition>
            <Suspense fallback={<ContentLoader />}>
              <Routes>
                <Route path="/" element={<HomeContent />} />
                <Route path="/que-esperar" element={<QueEsperarPage />} />
                <Route path="/experiencias" element={<ExperienciasContent />} />
                <Route path="/ubicaciones" element={<UbicacionesPage />} />
                <Route path="/eventos" element={<EventosPage />} />
                <Route path="/promociones" element={<PromocionesPage />} />

                {/* Experiencias individuales - rutas específicas (compatibilidad) */}
                <Route
                  path="/experiencias/far-cry"
                  element={<FarCryContent />}
                />
                <Route
                  path="/experiencias/space-marine"
                  element={<SpaceMarineContent />}
                />
                <Route
                  path="/experiencias/engineerium"
                  element={<EngineeriumContent />}
                />
                <Route
                  path="/experiencias/threat-lethal"
                  element={<ThreatLethalContent />}
                />

                {/* Ruta dinámica para cualquier experiencia por slug */}
                <Route
                  path="/experiencias/:slug"
                  element={<ExperienceDynamic />}
                />

                <Route
                  path="*"
                  element={
                    <div className="min-h-[60vh] flex items-center justify-center text-white">
                      Página no encontrada
                    </div>
                  }
                />
              </Routes>
            </Suspense>
          </PageTransition>
        </AppLayout>
        <CookiesBanner />
      </Router>
    </DeviceProvider>
  );
}

export default App;
